import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, trackPageView } from "@/lib/analytics";

/**
 * Bootstraps GA4 on first mount and fires a GA4 page_view on every route
 * change (including the initial mount). Uses a ref to guard against React
 * StrictMode double-invocation and against firing twice for the same path.
 */
export default function RouteAnalytics() {
    const location = useLocation();
    const lastPath = useRef(null);

    // Bootstrap gtag.js once.
    useEffect(() => { initAnalytics(); }, []);

    useEffect(() => {
        const fullPath = location.pathname + location.search;
        if (lastPath.current === fullPath) return;
        // Defer so document.title has settled from useSEO's effect. Mark the
        // path as tracked INSIDE the callback — under StrictMode the first
        // effect's timeout is cleared by cleanup, so marking eagerly would
        // swallow the initial page_view/PageView entirely.
        const id = setTimeout(() => {
            lastPath.current = fullPath;
            trackPageView(fullPath);
        }, 150);
        return () => clearTimeout(id);
    }, [location.pathname, location.search]);

    return null;
}
